import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import PartidoListar from '../../components/partido/listar';


function PartidoScreen () {
    return (
        <Fragment>
            <Head titulo="Notificação de Liberação de Recursos - Lei 9.452/1997"/>
            <Header />
            <Container>
                <PartidoListar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default PartidoScreen;